<template>
    <div v-if="childrenCustomFields">
        <draggable :list="childrenCustomFields" class="dragArea" :group="{ name:'people'}" v-bind="dragOptions" :class="childrenCustomFields.length>0?'group-exist-container':'group-empty-container'"> 
            <div v-for="(el, index) in childrenCustomFields" :key="'group'+index" class="list-group-item">
                <div class="list-item-container">
                    <p class="margin0">{{ index+1 }}. {{ el.name }} </p>
                    <div class="action-container">
                        <div class="round-btn" @click="getFormElement(index)"><i class="fas fa-pencil-alt" /></div>
                        <div class="round-btn" @click="removeEmitAt(index)"><i class="fa fa-times" /></div>
                    </div>
                </div>
                <!-- <local-draggable :childrenCustomFields="el.childrenCustomFields"></local-draggable> -->
            </div>
        </draggable>
    </div>
</template>

<script>
export default {
    name: "LocalDraggable",
    props: ["childrenCustomFields", "isNew"],
    computed: {
        dragOptions() {
            return {
                animation: 0,
                group: "description",
                disabled: false,
                ghostClass: "ghost"
            };
        }
    },
    methods: {
        getFormElement(index) {
            this.$emit("getFormGroupElement", index);
        },
        removeEmitAt(index) {
            this.$emit("removeGroup", index);
        },
    }
};
</script>

<style lang="css" scoped>
.list-item-container{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.ghost {
  opacity: 0.6;
  background: #c8ebfb;
}
.list-group-item {
  cursor: move;
}
.group-reminder{
    color: #8e8e8e;
    height: 30px;
    margin: 10px 16px 0px 16px;
}
.action-container{
    display: flex;
}
.group-exist-container{
    margin-top: 6px;
    padding: 0;
}
.group-empty-container{
    padding: 8px;
}
.group-empty-container::after{
    content: "Your group is still empty now";
    color: #8e8e8e;
    height: 30px;
    margin: 0 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/Configurations/CustomFormConfiguration/LocalDraggable.vue